import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Table from "../../../../../../components/table/table";
import { Typography } from "@mui/material";
import { Button } from "../../../../../../components/button/button";
import CreateProjectModal from "../../../../create-project-modal/create-project-modal";
import AddProjectsModal from "../add-projects-modal/add-projects-modal";
import { LinkedPlanStyled } from "../linked-plan/linked-plan.style";
import { EncircledPlusIcon } from "../../../../../../utils/svg-components";
import { groupPlanColumns } from "./columns";
import { formatNumber, isSomething } from "../../../../../../utils/utils";

const GroupPlanTable = ({ projectData, groupClient, companyDetails, isGeneralUser }) => {
  const { id } = useParams();

  const [showModal, setShowModal] = useState(false);

  const [showProjectModal, setShowProjectModal] = useState(false);

  const transformedData = projectData
    // ?.filter((x) => {
    //   const materialsBudget = x?.materials?.reduce(
    //     (sum, mat) => sum + parseFloat(mat.total || 0.0),
    //     0
    //   );
    //   const projectTotal = parseFloat(x?.projectTotal || 0);
    //   return materialsBudget + projectTotal !== 0;
    // })
    ?.map((project) => ({
      ...project,
      materials: formatNumber(
        parseFloat(
          project?.materials?.reduce(
            (sum, mat) => sum + parseFloat(mat.total || 0),
            0
          )
        )
      ),
      projectTotal: parseFloat(project?.projectTotal || 0),
      plannerServiceValue: parseFloat(project?.plannerServiceValue || 0),
    }));

  const noDataMessage = (
    <div className="no-data-message">
      <Typography style={{ fontWeight: "bold" }} variant="h6">
        There are no projects linked to this group.
      </Typography>
      <div className="create-cta">
        <Button
          onClick={() => setShowProjectModal(true)}
          size="large"
          startIcon={<EncircledPlusIcon />}
          variant="filled"
          color={"primary"}
        >
          Add Existing Project
        </Button>
        <Button
          onClick={() => setShowModal(true)}
          size="large"
          startIcon={<EncircledPlusIcon />}
          variant="filled"
          color={"tertiary"}
        >
          Add New Project
        </Button>
      </div>
    </div>
  );
  return (
    <LinkedPlanStyled>
      <div className="plans">
        <Typography variant="h6"> Linked Project Plans</Typography>

        <Table
          data={transformedData}
          columns={groupPlanColumns(companyDetails, isGeneralUser)}
          noDataMessage={noDataMessage}
        />
        {showModal && (
          <CreateProjectModal
            onClose={() => setShowModal(false)}
            defaultValues={{
              isGrouped: false,
              addToExistingProject: id,
              client: groupClient,
            }}
            onSuccess={() => {
              setShowModal(false);
            }}
          />
        )}
        {showProjectModal && (
          <AddProjectsModal
            projectData={projectData}
            onClose={() => setShowProjectModal(false)}
            onSuccess={() => {
              setShowProjectModal(false);
            }}
          />
        )}
        {isSomething(transformedData) && !isGeneralUser && (
          <div className="create-cta">
            <Button
              onClick={() => setShowProjectModal(true)}
              size="large"
              startIcon={<EncircledPlusIcon />}
              variant="filled"
              color={"primary"}
            >
              Add Existing Project
            </Button>
            <Button
              onClick={() => setShowModal(true)}
              size="large"
              startIcon={<EncircledPlusIcon />}
              variant="filled"
              color={"tertiary"}
            >
              Add New Project
            </Button>
          </div>
        )}
      </div>
    </LinkedPlanStyled>
  );
};

export default GroupPlanTable;
